import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']
  static values = { active: { type: String, default: 'fr' } }

  switch(event) {
    this.activeValue = event.currentTarget.dataset.locale
  }

  activeValueChanged() {
    this.tabTargets.forEach((tab) => {
      tab.classList.toggle('locale-tab-active', tab.dataset.locale === this.activeValue)
    })
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.locale !== this.activeValue
    })
  }
}
